import { ReleaseActivePointer } from "./types";

/** Customer-facing KrossKast App label from the V2 active-release pointer. */
export function formatKkAppActiveLabel(
  active: ReleaseActivePointer | null | undefined
): string {
  if (active?.type === "krosskast" && active.versionName) {
    return `krosskast-v${active.versionName}`;
  }
  return "None active";
}

export function formatKkAppActiveLabelWithCode(
  active: ReleaseActivePointer | null | undefined
): string {
  const base = formatKkAppActiveLabel(active);
  if (base === "None active" || active?.versionCode == null) {
    return base;
  }
  return `${base} (versionCode ${active.versionCode})`;
}
